var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay_success_page"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"text"},[_vm._v("支付成功")])])
}]

export { render, staticRenderFns }